var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "team-box" }, [
    _c("div", { staticClass: "image-box" }, [
      _c("img", { attrs: { src: _vm.planData.teamDto.imgUrl } }),
    ]),
    _c("div", [
      _c("div", { staticClass: "content-right-box" }, [
        _c("div", [
          _vm._m(0),
          _c("div", { staticClass: "text-box" }, [
            _c("div", { staticClass: "text-top" }, [
              _c("span", { staticClass: "font-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.planData.totalScore
                      ? Number(_vm.planData.totalScore).toFixed(2)
                      : "0"
                  )
                ),
              ]),
            ]),
            _c("span", { staticClass: "font-status" }, [
              _vm._v(" " + _vm._s(_vm.$t("showLxRecord.ZF")) + " "),
            ]),
          ]),
        ]),
      ]),
      _c(
        "p",
        [
          _c("el-tag", { attrs: { size: "mini" } }, [
            _vm._v(" " + _vm._s(_vm.$t("showLxRecord.TDMC")) + " "),
          ]),
          _c(
            "span",
            {
              staticClass: "team-name",
              attrs: { title: _vm.planData.teamDto.teamName },
            },
            [_vm._v(_vm._s(_vm.planData.teamDto.teamName))]
          ),
        ],
        1
      ),
      _c(
        "p",
        [
          _c("el-tag", { attrs: { size: "mini" } }, [
            _vm._v(" " + _vm._s(_vm.$t("showLxRecord.DZXM")) + " "),
          ]),
          _c(
            "span",
            {
              staticClass: "leader-name",
              attrs: { title: _vm.planData.teamDto.leaderName },
            },
            [_vm._v(" " + _vm._s(_vm.planData.teamDto.leaderName) + " ")]
          ),
        ],
        1
      ),
      _c(
        "p",
        [
          _c("el-tag", { attrs: { size: "mini" } }, [
            _vm._v(" " + _vm._s(_vm.$t("showLxRecord.LXSJ")) + " "),
          ]),
          _c(
            "span",
            {
              staticClass: "status-text nowrap",
              attrs: {
                title: `${_vm.planData.teamDto.startTime} - ${_vm.planData.teamDto.submitTime}`,
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.planData.teamDto.startTime) +
                  " - " +
                  _vm._s(_vm.planData.teamDto.submitTime) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", { attrs: { src: require("@/assets/image/jiaojuan.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }